// Generates a random UPI transaction reference (tr) so the QR's payment
// link is unique per render — a static QR/amount pair could otherwise be
// screenshotted and reused, or make reconciling duplicate payments harder.
export default function generateTxnRef() {
  const bytes = new Uint8Array(8);
  window.crypto.getRandomValues(bytes);
  const random = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `GSH${Date.now().toString(36).toUpperCase()}${random.toUpperCase()}`;
}
